<template>
<div class="papsi-wrapper">
    <h1 class="text-2xl font-bold text-[#016B00]">DASHBOARD</h1>
    <p class="text-xs text-[#747474] mt-2">Home / Dashboard</p>
</div>


<div class="papsi-wrapper mt-6 w-full">
    <div class="papsi-container w-full flex flex-col gap-6 ">
            <div class="grid grid-cols-4 gap-7">
                <div class="border-[#58bbcc] border-[2px] bg-[#f0f0f0] rounded-xl flex justify-between py-5 px-7 shadow-lg items-center col-span-1 max-xl:col-span-2">
                    <div class="">
                        <p class="text-sm font-bold bg-[#016B00  text-[#9e9c9c]">TOTAL EMPLOYEES</p>
                        <p class="font-bold text-[35px] text-[#016B00]">256</p>
                    </div>
                    <div class="">
                        <TestLogo/>
                    </div>
                </div>
                <div class="border-[#58bbcc] border-[2px] bg-[#f0f0f0] rounded-xl flex justify-between py-5 px-7 shadow-lg items-center col-span-1 max-xl:col-span-2">
                    <div class="">
                        <p class="text-sm font-bold bg-[#016B00  text-[#9e9c9c]">TOTAL EMPLOYEES</p>
                        <p class="font-bold text-[35px] text-[#016B00]">256</p>
                    </div>
                    <div class="">
                        <TestLogo/>
                    </div>
                </div>
                <div class="border-[#58bbcc] border-[2px] bg-[#f0f0f0] rounded-xl flex justify-between py-5 px-7 shadow-lg items-center col-span-1 max-xl:col-span-2">
                    <div class="">
                        <p class="text-sm font-bold bg-[#016B00  text-[#9e9c9c]">TOTAL EMPLOYEES</p>
                        <p class="font-bold text-[35px] text-[#016B00]">256</p>
                    </div>
                    <div class="">
                        <TestLogo/>
                    </div>
                </div>
                <div class="border-[#58bbcc] border-[2px] bg-[#f0f0f0] rounded-xl flex justify-between py-5 px-7 shadow-lg items-center col-span-1 max-xl:col-span-2">
                    <div class="">
                        <p class="text-sm font-bold bg-[#016B00  text-[#9e9c9c]">TOTAL EMPLOYEES</p>
                        <p class="font-bold text-[35px] text-[#016B00]">256</p>
                    </div>
                    <div class="">
                        <TestLogo/>
                    </div>
                </div>



            </div>

            <div class="w-full grid grid-cols-2 gap-8">
                <div class="bg-[#f0f0f0] rounded-xl flex py-5 px-8 shadow-lg  flex-col border-[#a07536] border-[2px] max-xl:col-span-2 ">
                    <p class="font-semibold text-lg text-[#016B00]">FORM REQUEST</p>
                    <div class="flex flex-col mt-5">
                        <p class="text-sm font-semibold py-2 text-[#026b00b4]">Leave Form</p>
                        <div class="bg-[#f8f8f8] rounded-lg shadow-lg flex border-[#e9e7e7] border py-5 px-5 gap-5">
                            <div class="text-center w-[33%]">
                                <p class="text-lg font-bold text-[#016B00]">25</p>
                                <p class="text-[#aaa7a7] font-semibold text-sm">PENDING</p>
                            </div>
                            <div class="text-center w-[33%] border-[#afacac] border-x">
                                <p class="text-lg font-bold text-[#016B00]">25</p>
                                <p class="text-[#aaa7a7] font-semibold text-sm">APPROVED</p>
                            </div>
                            <div class="text-center w-[33%]">
                                <p class="text-lg font-bold text-[#016B00]">25</p>
                                <p class="text-[#aaa7a7] font-semibold text-sm">DISAPPROVED</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col mt-5">
                        <p class="text-sm font-semibold py-2 text-[#026b00b4]">Consideration Form</p>
                        <div class="bg-[#f8f8f8] rounded-lg shadow-lg flex border-[#945d5d] border py-5 px-5 gap-5 ">
                            <div class="text-center w-[33%]">
                                <p class="text-lg font-bold text-[#016B00]">25</p>
                                <p class="text-[#aaa7a7]  font-semibold text-sm">PENDING</p>
                            </div>
                            <div class="text-center w-[33%] border-[#afacac] border-x">
                                <p class="text-lg  font-bold text-[#016B00]">25</p>
                                <p class="text-[#aaa7a7] font-semibold text-sm">APPROVED</p>
                            </div>
                            <div class="text-center w-[33%]">
                                <p class="text-lg  font-bold text-[#016B00]">25</p>
                                <p class="text-[#aaa7a7] font-semibold text-sm">DISAPPROVED</p>
                            </div>
                        </div>
                    </div>


                </div>

                <div class="bg-[#f0f0f0] rounded-xl flex flex-col py-5 px-8 shadow-lg  border-[#586b25] border-[2px] max-xl:col-span-2 ">
                    <p class="font-semibold text-lg text-[#016B00] ">DAILY USERS</p>
                    <div class="w-full">
                        <img class="w-full h-[290px] object-fit " src="../../assets/SampleChart.png">
                    </div>

                </div>
            </div>


            <div class="w-full h-[200px] bg-[#f0f0f0] rounded-xl border-[#7c3360] border-[2px]" >
                <p class="text-sm font-semibold text-[#026b00b4] px-5 py-4">SAMPLE DATA</p>
            </div>
    </div>
</div>

        
</template>


<script>

    import { defineComponent } from 'vue';
    import TestLogo from '../icons/SampleLogo.vue' 
    
    export default defineComponent(
    {
        components:{
            TestLogo
        },

    })

</script>